// extracted by mini-css-extract-plugin
export default {"container":"AppleChart_container__2epWx","chart":"AppleChart_chart__4fbrt"};